/* eslint-disable max-len */
/**
 * French translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DOWNLOAD_IMAGE: 'Il n\'a pas été possible de télécharger l\'image',
    ERROR: 'Erreur'
  },
  HEADER: {
    DESCRIPTION: 'Description',
    END_DATE: 'Jusqu\'à',
    ID: 'ID',
    START_DATE: 'Le',
    TITLE: 'Titre'
  },
  LABEL: {
    ACTIVES: 'Campagnes actives',
    CAMPAIGNS_SIGN_OR: 'Ou',
    CAMPAIGNS_SIGN_PLUS: '+',
    COUPON: 'Coupon',
    DESCRIPTION: 'Description',
    DESIGN_REQUESTS: 'Demandes de conception',
    DESIGN_REQUESTS_ACTIVES: 'Demandes de conception actives',
    DESIGN_REQUESTS_TERMINATED: 'Commandes de conception terminées',
    DETAIL: 'Détail',
    END_DATE: 'Jusqu\'à',
    FILES_TITLE: 'Ressources des campagnes',
    FILES_TITLE_DESIGN_REQUEST: 'Ressources pour la demande de désignation',
    FINISHED: 'Achevée',
    FINISHED_DESIGN_REQUEST: 'Fini',
    GENERATED: 'Généré',
    GENERIC_DESIGN: 'Conception générique',
    ID: 'ID',
    IN_PROGRESS: 'En cours',
    NO_ROWS_CAMPAIGNS: 'Pas de campagnes',
    NO_ROWS_DESIGN_REQUESTS: 'Pas de demandes de conception',
    OFFER: 'Offrir',
    PREVIOUS_LEVEL: 'Niveau précédent',
    START_DATE: 'Le',
    STATUS: 'Statut',
    TERMINATED: 'Campagnes terminées',
    TITLE: 'Titre',
    VALUE: 'Évaluer'
  },
  SENTENCE: {
    ATTACHMENT_DESCRIPTION:
      'Aucun Pièces jointes des campagnes (pour l\'instant).',
    ATTACHMENT_DESCRIPTION_DESIGN_REQUEST:
      'Pas de pièces jointes pour cette demande de design (pour l\'instant).',
    ATTACHMENT_TITLE: 'Aucun pièces jointes.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
